import {SampleGroup} from 'workflows/WorkflowConstants';

export enum SampleGroupActionType {
  SAMPLE_GROUPS_FETCH_COMPLETED = 'SAMPLE_GROUP_FETCH_COMPLETED',
}

interface SampleGroupsFetchCompletedAction {
  type: SampleGroupActionType.SAMPLE_GROUPS_FETCH_COMPLETED;
  sampleGroups: Array<SampleGroup>;
}

export function sampleGroupsFetchCompleted(
  sampleGroups: Array<SampleGroup>
): SampleGroupsFetchCompletedAction {
  return {
    type: SampleGroupActionType.SAMPLE_GROUPS_FETCH_COMPLETED,
    sampleGroups,
  };
}

export type SampleGroupAction = SampleGroupsFetchCompletedAction;
